import React from 'react';

import GroupQuotaList  from 'components/Tvendo/Sale/QuotaBPartner/Colgate/GroupQuota/List.js';

export default function () {
  return <GroupQuotaList  />;
}